import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';

import { firebaseConfig } from '../constants/defaultConfig';

firebase.initializeApp(firebaseConfig);

const authFB = firebase.auth();
const auth = firebase.auth();
const database = firebase.firestore();
const analytics = firebase.analytics();
const db = firebase.firestore();
const storage = firebase.storage();

export { auth, authFB, database, analytics, db, storage, firebase };
